import { render, staticRenderFns } from "./warehouseVideo.vue?vue&type=template&id=7473e918&scoped=true&"
import script from "./warehouseVideo.vue?vue&type=script&lang=js&"
export * from "./warehouseVideo.vue?vue&type=script&lang=js&"
import style0 from "./warehouseVideo.vue?vue&type=style&index=0&id=7473e918&prod&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7473e918",
  null
  
)

export default component.exports